// extracted by mini-css-extract-plugin
module.exports = {"conteudos":"Drive_conteudos__1PcCZ"};